import { Subject } from "../models/common.reactive";

export interface Select2AjaxSource {
	url: string;
	dataType: string;
	delay: number;
	cache: boolean;
	type: string;
	traditional?: boolean;
	escapeMarkup?: (markup: string) => string;
	data?: (params: any) => any;
	params?: any,
	processResults?: (data, query) => {
		results: any[]
	},
	transport?: (params, success, failure) => any;

	getInitOptionsFn?: () => InternalSelect2Option[];
}

export interface Select2Config {
	limit?: number;
	allowClear?: boolean;
	language?: string;

	matcher?: (params, data) => any,
	tags?: boolean | Function,
	createTag?: (params: any) => any;
	insertTag?: (data: any, tag: any) => void;

	templateResult?: (state: any, a, b, c) => string | JQuery;
	templateSelection?: (state: any, a, b, c) => string | JQuery;
	minimumInputLength?: number;
	maximumInputLength?: number;

	data?: InternalSelect2Option[];
	ajax?: Select2AjaxSource;
	width?: string;
	multiple?: boolean;
	placeholder?: string;
	search?: boolean;

	disabled?: boolean;

	initSelection?: (element: any, callback: any) => void;
	onChange?: () => void;

	getTrackIdFn?: (obj: any) => any;
	getValueFn?: (obj: any) => any;

	clear?: Subject<void>;

	dropdownParent?: any;
	dropdownAutoWidth?: boolean;
}


let defaultOptions: Select2Config = {
	width: '100%'
};

declare var angular: ng.IAngularStatic;

const sortedKeys = function (obj) {
	var keys = [];
	for (var key in obj) {
		if (obj.hasOwnProperty(key)) {
			keys.push(key);
		}
	}
	return keys.sort();
}

interface Select2Option {
	id: number;
	text: string;
}

interface InternalSelect2Option extends Select2Option {
	obj?: any;
}

interface Select2Scope extends ng.IScope {
	select2: any;
	options: any;
}

/* @ngInject */
export function Select2Directive (
	$parse: ng.IParseService,
	$timeout: ng.ITimeoutService,
	$filter: ng.IFilterService,
	select2Config: Select2Config,
	select2Stack: Select2StackService,
	$log: ng.ILogService) {

	if (select2Config) {
		Object.assign(defaultOptions, select2Config);
	}
	let filter = $filter("filter");

	return {
		restrict: "E",
		scope: {
			options: "<"
		},
		require: "ngModel",
		priority: 1,
		replace: true,
		template: `<select class="form-control"></select>`,
		link: async (scope: Select2Scope, element, attrs, controller: ng.INgModelController) => {
			var getOptions;

			// Чтобы инициализация не происходила, пока контроллер не передаст options
			function isPromise(obj) {
				return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
			}

			var scopeOptions = !!scope && isPromise(scope.options) ? await scope.options : scope.options;
			//

			var opts: Select2Config = Object.assign({}, defaultOptions, scopeOptions);

			opts.width = attrs.width || opts.width;

			var isMultiple = angular.isDefined(attrs.multiple) || opts.multiple;

			opts.multiple = isMultiple;

			// make sure ngrequired validation works
			if (isMultiple) {
				controller.$isEmpty = function (value) {
					return !value || value.length === 0;
				};
			}

			if (attrs.placeholder) {
				opts.placeholder = attrs.placeholder;
			}

			var filterOptions = $parse(attrs.optionsFilter);

			var optionItems = {};

			let filterValues = (values) => {
				if (filterOptions) {
					var filterParams = filterOptions(scope);
					if (filterParams) {
						return filter(values, filterParams);
					}
				}

				return values;
			}

			// todo: костыль
			let forceFocusFn = () => {
				let searchInput = $('.select2-container--open .select2-search__field');

				if (searchInput && searchInput.length) {
					searchInput.get(0).focus();
				}
			};

			$(document).ready(() => {
				$(document).on('select2:open', () => {
					$timeout(() => forceFocusFn(), 10)
				});
			});

			//функция определения идентификатора опции. по умолчанию - сама опция
			let getTrackIdFn = (obj) => obj;

			//функция определения модели значения опции. по умолчанию - сама опция
			let getValueFn = (obj) => obj;

			let expressionScope;
			if(attrs.parentScopeType){
				expressionScope = attrs.parentScopeType == "parent"
					? scope.$parent
					: scope.$parent.$parent;
			}
			else{
				expressionScope = scope.$parent.$parent;
			}
			 

			let runWatch = (): void => {
				scope.$watch(() => controller.$modelValue, (newVal, oldVal) => {
					// #40387. oldVal - приходил всегда null или undefined, соответсвенно сразу выходили, а для первоначального выставления значения согласно модели - надо было пройти дальше
					// if (newVal == undefined || oldVal == undefined) {
					// 	return;
					// }

					if (newVal == undefined || newVal == null) {
						return;
					}

					//if (!angular.equals(newVal, oldVal)) { newVal, oldVal - как-то не очень логично приходят, одно значение есть, другое null?
						$log.debug("reset", element, newVal);
						controller.$render();
						$timeout(() => scope.select2.trigger("change.select2"));
					//}
				});
			}

			let prepareOptsData = (): void => { };

			let defineGetOptions = (): void => {
				if (attrs.s2Options) {
					opts.data = $parse(attrs.s2Options)(expressionScope);
				}
				else if (opts.data) {
				prepareOptsData = (): void => opts.data.forEach(opt => {
					if (opt.obj === undefined) {
						opt.obj = opt.id;
					}
				});
				}

				getOptions = (callback) => {
					prepareOptsData();
					callback(opts.data);
				}

				runWatch();
			}

			if (attrs.s2Options) {
				var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
				var match = attrs.s2Options.match(NG_OPTIONS_REGEXP);

				//конфигурация 
				if (match) {
					var displayFn = $parse(match[2] || match[1]);
					var valuesFn = $parse(match[7]);
					var valueName = match[4] || match[6];
					var valueFn = $parse(match[2] ? match[1] : valueName);
					var keyName = match[5];

					let trackByFn;
					if (match[8]) {
						//если указано выражение track by - используем его для идентификации опций
						trackByFn = $parse(match[8]);
					}
					else {
						//иначе используем выражение value
						trackByFn = valueFn;
					}

					getTrackIdFn = (obj) => {
						var locals = {};
						locals[valueName] = obj;
						return trackByFn(expressionScope, locals);
					}

					getValueFn = (obj) => {
						var locals = {};
						locals[valueName] = obj;
						return valueFn(expressionScope, locals);
					}

					getOptions = function (callback) {
						optionItems = {};
						const matchValues = valuesFn(expressionScope);
						var values = filterValues(matchValues);
						var keys = (keyName ? sortedKeys(values) : values) || [];

						var options = [];
						for (var i = 0; i < keys.length; i++) {
							var locals = {};
							var key = i;
							if (keyName) {
								key = keys[i];
								locals[keyName] = key;
							}
							locals[valueName] = values[key];

							let value = valueFn(expressionScope, locals) || values[key];

							var label = displayFn(expressionScope, locals) || "";
							var trackId = trackByFn(expressionScope, locals);

							// Select2 returns strings, we use a dictionary to get
							// back to the original value.
							optionItems[trackId] = {
								id: trackId,
								text: label,
								obj: value
							};

							options.push(optionItems[trackId]);
						}

						callback(options);
					};

					getOptions((options) => {
						opts.data = options;
					})

					expressionScope.$watch(match[7], () => {
						getOptions((options) => {
							opts.data = options;
							if (scope.select2) {
								element.empty().select2(opts);
							}
							controller.$render();
						})
					});

					runWatch();

				}
				else {
					defineGetOptions();
				}
			}
			// todo: задублировал код выше
			else if (opts.data) {
				getTrackIdFn = opts.getTrackIdFn || ((obj) => {
					return obj?.id;
				});

				getValueFn = opts.getValueFn || ((obj) => {
					return obj?.id;
				});

				defineGetOptions();
			}

			if (opts.clear) {
				opts.clear.subscribe(() => {
					element.val("").trigger("change").trigger("select2:select");
				})
			}

			if (opts.ajax) {
				let options = [];
				let proxiedFunc = opts.ajax.processResults;

				getTrackIdFn = (obj) => {
					return obj?.id;
				}

				if (opts.ajax.getInitOptionsFn) {
					options = opts.ajax.getInitOptionsFn();
				}

				opts.ajax.processResults = (data, query) => {
					let result = proxiedFunc(data, query);

					options = result.results.map(i => ({ id: i.id, text: i.text, obj: i }));

					return result;
				}

				if (opts.initSelection) {
					let _initSelection = opts.initSelection;
					opts.initSelection = function (element, callback) {
						_initSelection(element, function (result) {
							if (result && result.id) {
								options.push({ id: result.id, text: result.text, obj: result });
							}
							callback(result);
						});
					};

				}

				getOptions = (callback) => {
					callback(options);
				}

				runWatch();
			}

			function getSelection(callback) {
				if (isMultiple) {
					//todo. trackby
					getOptions(function (options) {
						var selection = [];
						let viewValue = controller.$viewValue || [];

						for (var i = 0; i < viewValue.length; i++) {
							var value = viewValue[i];
							const trackId = getTrackIdFn(value) || value;
							let optionItem = options.find(x => x.id == trackId);

							if (optionItem) {
								selection.push(optionItem);
							}
							else if (opts.tags) {
								//todo. make item by external function in options
								let tagItem = { id: trackId, text: trackId };
								selection.push(tagItem);
							}
						}

						// for (var i = 0; i < options.length; i++) {
						// 	var option = options[i];
						// 	if (viewValue.indexOf(option.id + "") > -1) {
						// 		selection.push(option);
						// 	}
						// }
						callback(selection);
					});
				} else {
					getOptions(function (options) {
						let trackId = getTrackIdFn(controller.$viewValue);
						if (!trackId && trackId != 0) {
							trackId = controller.$viewValue;
						};
						let optionItem = options.find(x => x.id == trackId);
						callback(optionItem || { obj: {} });
					});
				}
			}

			if (!opts.initSelection) {
				opts.initSelection = function (element, callback) {
					getSelection(callback);
				};
			} else {
				var _initSelection = opts.initSelection;
				opts.initSelection = function (element, callback) {
					_initSelection(element, function (result) {
						if (result && result.id) {
							optionItems[result.id] = result;
						}
						callback(result);
					});
				};
			}

			// register with the select2stack
			var controlObj = {
				close: function () {
					element.select2("close");
				}
			};

			select2Stack.$register(controlObj);
			scope.$on("destroy", () => {
				select2Stack.$unregister(controlObj);
			});

			const setSelection = () => {
				getSelection((selection) => {
					let setVal = null;

					if (isMultiple) {
						setVal = selection.map(x => x.id + "");
					}
					else if (selection.id) {
						setVal = selection.id + "";
					}

					if (setVal) {
						scope.select2.val(setVal);
					}
				});
			}

			const forceInit = () => {
				if (!isMultiple && opts.search) {
					scope.select2.val(null);
				}
			}

			controller.$render = () => {
				if (!scope.select2) {
					$log.debug("configure", element, opts);
					scope.select2 = element.select2(opts);

					if (!opts.ajax) {
						// сбивает выбор при ajax инициализации
						$timeout(() => scope.select2.trigger("change.select2"));
					}

					// при первичной отрисовке явно инициализирует элемент с поиском
					// единственного выбора значением null
					forceInit();
				}

				if (!opts.ajax) {
					setSelection();
				}
			};

			$timeout(() => {
				if (!scope.select2) {
					$log.debug("configure", element, opts);
					scope.select2 = element.select2(opts);
				}

				element.on("change", function (e) {
					scope.$applyAsync(function () {
						const trackId = element.select2("val");

						if (isMultiple) {

							getOptions(function (options) {

								let ids: string[] = trackId || [];
								let optionItems = ids.map(id => options.find(x => x.id == id) || { id: id, obj: id, text: id });

								let values = optionItems.map(o => getValueFn(o));

								//по-хорошему это разрешено только в режиме добавления
								controller.$setViewValue(values);
								controller.$render();

								if (opts.onChange) {
									$timeout(() => opts.onChange());
								}
							});
						} else {
							getOptions(function (options) {
								let optionItem = options.find(x => x.id == trackId);
								//по-хорошему это разрешено только в режиме добавления
								optionItem = optionItem || { obj: trackId };
								controller.$setViewValue(optionItem.obj);
								controller.$render();

								if (opts.onChange) {
									$timeout(() => opts.onChange());
								}
							});
						}
					});
				});

				element.on("select2-blur", function () {
					if (controller.$touched) {
						return;
					}

					scope.$evalAsync(function () {
						return controller.$setTouched();
					});
				});
			});
		}
	}
}

Select2Directive.selector = "select2";

export const Select2Config = {

}

var stack = [];
export class Select2StackService {
	$register(callbackElem) {
		stack.push(callbackElem);
	}

	$unregister(callbackElem) {
		var idx = stack.indexOf(callbackElem);
		if (idx !== -1) {
			stack.splice(idx, 1);
		}
	}

	closeAll() {
		stack.forEach(function (elem) {
			elem.close();
		});
	}
}
